import jwtDecode from 'jwt-decode';
import {
    ROLE_SUPER_ADMIN,
    ROLE_ADMIN,
    ROLE_RESELLER
} from '../constants/constants';
import avatarW2Z from "../assets/images/users/w2z.jpg";
import avatarHemodiag from "../assets/images/users/hemodiag.jpg";
import avatarM3logsol from "../assets/images/users/m3logsol.jpg";
import avatarCaorc from "../assets/images/users/caorc.jpg";
import avatarCms from "../assets/images/users/cmsocupacional.jpg";
import avatarTabeliaoRc from "../assets/images/users/tabeliaorc.jpeg";
import avatarCardoCorretora from "../assets/images/users/cardocorretora.jpeg";
import avatarFarmaciaRhaizes from "../assets/images/users/farmaciarhaizes.jpeg";
import avatarFarmaciaSaoJoao from "../assets/images/users/farmaciasaojoao.jpg";
import avatarConsDrItamarPerez from "../assets/images/users/consdritamarperez.jpg";
import avatarRoncoli from "../assets/images/users/roncoli.jpeg";
import avatarUnidadeCardiologicaRc from "../assets/images/users/unidadecardiologicarc.jpeg";
import avatarCafMaquinas from "../assets/images/users/cafmaquinas.jpg";
import avatarEscritorioIpiranga from "../assets/images/users/escritorioipiranga.jpg";
import avatarCasaDasCriancas from "../assets/images/users/casadascriancas.jpg";

/**
 * Checks if user is authenticated
 */
const isUserAuthenticated = () => {
    const user = getLoggedInUser();
    if (!user) {
        return false;
    }

    try {
        const decoded = jwtDecode(user.token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
            console.warn('access token expired');
            localStorage.removeItem("authUser"); // remove from localstorage
            return false;
        }
        else {
            return true;
        }
    } catch (e) {
        console.warn('access token expired');
        localStorage.removeItem("authUser"); // remove from localstorage
        return false;
    }
}

/**
 * Sets the logged in user
 */
const setLoggedInUser = (user) => {
    localStorage.setItem('authUser', JSON.stringify(user));
}

/**
 * Returns the logged in user
 */
const getLoggedInUser = () => {
    const user = localStorage.getItem('authUser');
    return user ? (typeof (user) == 'object' ? user : JSON.parse(user)) : null;
}

const getHomeByLoggedInUser = () => {
    const user = localStorage.getItem('authUser');
    let userLogged = user ? (typeof (user) == 'object' ? user : JSON.parse(user)) : null;

    switch (userLogged.data.roles[0]?.name.toString()) {
        case ROLE_SUPER_ADMIN:
            return "/wzap-administrator";
        case ROLE_ADMIN:
            return "/panel";
        case ROLE_RESELLER:
            return "/dashboard";
        default:
            return "/dashboard";
    }
}

const getAvatarByLoggedUser = () => {
    const userLogged = getLoggedInUser();
    const { imageClient } = userLogged?.data || {};
    return getAvatarByImageName(imageClient);
}

const getAvatarByImageName = (imageName) => {
    switch (imageName) {
        //Hemodiag
        case 'hemodiag.jpg':
            return avatarHemodiag;
        //M3logSol
        case 'm3logsol.jpg':
            return avatarM3logsol;
        //CAORC
        case 'caorc.jpg':
            return avatarCaorc;
        //3 Tabeliao RC
        case 'tabeliaorc.jpg':
            return avatarTabeliaoRc;
        //CMS Ocupacional
        case 'cmsocupacional.jpg':
            return avatarCms;
        //Cardo & Oliveira Corretora de Seguros
        case 'cardocorretora.jpeg':
            return avatarCardoCorretora;
        //Farmacia Rhaizes
        case 'farmaciarhaizes.jpeg':
            return avatarFarmaciaRhaizes;
        //Farmacia São João
        case 'farmaciasaojoao.jpg':
            return avatarFarmaciaSaoJoao;
        //Consultório Dr Itamar Perez
        case 'consdritamarperez.jpg':
            return avatarConsDrItamarPerez;
        //Mangueiras 3R
        case 'roncoli.jpeg':
            return avatarRoncoli;
        //Unidade Cardiológica não Invasiva de Rio Claro
        case 'unidadecardiologicarc.jpeg':
            return avatarUnidadeCardiologicaRc;
        //CAF Máquinas
        case 'cafmaquinas.jpg':
            return avatarCafMaquinas;
        //Escritório Ipiranga
        case 'escritorioipiranga.jpg':
            return avatarEscritorioIpiranga;
        //Casa das Crianças
        case 'casadascriancas.jpg':
            return avatarCasaDasCriancas;
        default:
            return avatarW2Z;
    }
}

export { isUserAuthenticated, setLoggedInUser, getLoggedInUser, getHomeByLoggedInUser, getAvatarByLoggedUser, getAvatarByImageName };